import React from "react";

export const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const fmtDT = (iso) => { const d = new Date(iso); return !iso || isNaN(d) ? "—" : d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }); };
export const fmtD = (s) => (s ? s.slice(0, 10).split("-").reverse().join("/") : "—");
export const METHOD = { pix: "Pix", bank_transfer: "Pix", credit_card: "Cartão de crédito", debit_card: "Cartão de débito", ticket: "Boleto", account_money: "Saldo MP" };
export const STATUS_CLS = {
  approved: "bg-green-50 text-green-700", pending: "bg-amber-50 text-amber-700", in_process: "bg-amber-50 text-amber-700",
  rejected: "bg-red-50 text-red-700", cancelled: "bg-slate-100 text-slate-600", refunded: "bg-purple-50 text-purple-700",
  charged_back: "bg-red-100 text-red-800", mp_error: "bg-red-50 text-red-700",
};
export const Badge = ({ status, label }) => (
  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap ${STATUS_CLS[status] || "bg-slate-100 text-slate-600"}`}>{label || status}</span>
);
// valor zerado fica cinza (um "R$ 0,00" vermelho parecia alerta sem ter nada vencido)
const zerado = (v) => /^(R\$\s?)?0(,00)?$/.test(String(v ?? "").replace(/\u00a0/g, " ").trim());
export const Stat = ({ label, value, tone = "#232D4F" }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-4">
    <div className="text-xs font-semibold text-slate-500">{label}</div>
    <div className="font-display text-2xl font-bold mt-1" style={{ color: zerado(value) ? "#94A3B8" : tone }}>{value}</div>
  </div>
);
/** Nome do curso: o do Método vira etiqueta curta ("Nível Básico"); o nome completo aparece ao passar o mouse. */
export const CursoCurto = ({ titulo }) => {
  const m = /^(?:Curso\s+)?Cabeleireiro Cient[ií]fico Formulador\s*[-–]\s*(.+)$/i.exec(titulo || "");
  if (!titulo) return "—";
  return m
    ? <span title={titulo} className="inline-flex whitespace-nowrap rounded-lg bg-[#232D4F]/[.06] px-2.5 py-1 text-xs font-semibold text-[#232D4F]">{m[1].replace(/^N[ií]vel /i, "Nível ")}</span>
    : <span title={titulo} className="block truncate max-w-[200px]">{titulo}</span>;
};
export const Header = ({ title, sub, right }) => (
  <div className="flex items-center justify-between gap-4 flex-wrap">
    <div><h1 className="font-display text-3xl font-bold text-slate-900">{title}</h1>{sub && <p className="text-slate-500 mt-1">{sub}</p>}</div>
    {right}
  </div>
);
